// extracted by css-extract-rspack-plugin
export default {"improvePrompt":"ImprovePrompt-module__improvePrompt__jpF00Mv"};